import { Component, input, output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserContext } from '../../services/context.service';

@Component({
  selector: 'lr-portal-selector',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './portal-selector.component.html',
  styleUrls: ['./portal-selector.component.scss']
})
export class PortalSelectorComponent {
  context = input.required<UserContext>();
  selectedPortal = output<string>();

  onPortalSelect(portalName: string): void {
    this.selectedPortal.emit(portalName);
  }

  getPortalDisplayName(portalName: string): string {
    const displayNames: Record<string, string> = {
      'client': 'Client Portal',
      'member': 'Member Portal',
      'attorney': 'Attorney Portal'
    };
    return displayNames[portalName] || portalName;
  }
}
